(function () {
    'use strict';
    angular.module('SMART2').factory('browserSniffing', [function () {
        var ua = navigator.userAgent, tem,
                   old_ie = ua.indexOf('MSIE '), //IE browser version less than 11
                    new_ie = ua.indexOf('Trident/'), //IE browser version greater or equal to 11
               M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        //For checking if browser is from Internet Explorer family
        if (/trident/i.test(M[1]) || /MSIE/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            if (tem.length == 0) {
                return 'IE ' + (M[2] || '');
            } else {
                return 'IE ' + (tem[1] || '');
            }
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null)
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null)
            M.splice(1, 1, tem[1]);
        return M; // returning browser name and browser version
    }]);

    angular.module('SMART2').directive('smartBrowserSniffing', ['$window', '$timeout', '$translate', 'browserSniffing', 'notification', 'APPCONSTANTS', 'favoriteOps', function ($window, $timeout, $translate, browserSniffing, notification, APPCONSTANTS, favoriteOps) {
        return {
            restrict: 'A',
            scope: {
                showSniffing: '@',
            },
            templateUrl: 'shared/directives/uiElements/smartBrowserSniffing/browerSniffingTemplate.html',
            link: function (scope, element) {
                var showSniffing = (scope.showSniffing == 'true') ? true : false;
                scope.image960 = APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/workspace/shared/resources/images/browser-sniff/960-error-trans.png";
                scope.image1920 = APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/workspace/shared/resources/images/browser-sniff/1920-error-trans.png";
                var iconIE = APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/workspace/shared/resources/images/browser-sniff/IE.png",
                    iconChrome = APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/workspace/shared/resources/images/browser-sniff/Chrome.png",
                    iconEdge = APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/workspace/shared/resources/images/browser-sniff/Edge.png",
                    iconSafari = APPCONSTANTS.userPreferences.URLs.ContentURL + "smartcontent/workspace/shared/resources/images/browser-sniff/Safari.png";
                scope.isShowSniffer = favoriteOps.getSnifferFlag();
                if (showSniffing == true) {
                    $timeout(function () {
                        if (!scope.isShowSniffer)
                            scope.execBrowserSniffing();
                    });

                    angular.element($window).bind('resize', function () {
                        if (!scope.isShowSniffer)
                            scope.execBrowserSniffing();
                    });

                    scope.Screen960 = false;
                    scope.Screen1920 = false;

                    scope.execBrowserSniffing = function () {
                        scope.sniffTemplateUrl = "";
                        angular.element('html').css('overflow', 'hidden');

                        if (!scope.isShowSniffer) {
                            if (angular.element($window).innerWidth() < 960 || angular.element($window).innerWidth() > 1920) {
                                if (angular.element($window).innerWidth() < 960) {
                                    scope.Screen960 = true;
                                    scope.sniffTemplateUrl = "shared/directives/uiElements/smartBrowserSniffing/Browse960.html";
                                    element.addClass('active');
                                    scope.$apply();
                                }
                                if (angular.element($window).innerWidth() > 1920) {
                                    scope.Screen1920 = true;
                                    scope.sniffTemplateUrl = "shared/directives/uiElements/smartBrowserSniffing/Browse1920.html";
                                    element.addClass('active');
                                    scope.$apply();
                                }
                            }
                            else {
                                element.removeClass('active');
                                angular.element('html').removeAttr('style');
                            }
                            angular.element('.sniffingContainer').animate({ scrollTop: 1000 }, 'slow');
                        }
                    }

                    scope.onChange = function (isTrue) {
                        scope.isShowSniffer = isTrue;
                    }

                    scope.hideSniffingOverlay = function () {
                        scope.Screen1920 = false;
                        scope.Screen960 = false;
                        element.removeClass('active');
                        angular.element('html').removeAttr('style');
                        favoriteOps.setSnifferFlag(scope.isShowSniffer);
                    }
                    if (!(typeof browserSniffing === 'object')) {
                        browserSniffing = browserSniffing.split(' ');
                    }
                    var browserDetail = browserSniffing;

                    var unsupportedBrowser = {};

                    if (APPCONSTANTS && APPCONSTANTS.userPreferences && APPCONSTANTS.userPreferences.IsNextGen) {
                        unsupportedBrowser = {
                            type: "unsupportedBrowser",
                            message: $translate.instant("Platform_IncompatibleBrowserVersionMsg") + "<ul class=\"browser-list\"><li><a href=\"https://www.google.com/chrome/browser/desktop/index.html?brand=CHBD&gclid=EAIaIQobChMIuPufvL320gIVwpe9Ch3VhQUtEAAYASAAEgJ8ifD_BwE\" target=\"_blank\"><img src=" + iconChrome + " /><p>" + $translate.instant('Platform_BrowserChromeVersion') + "</p></a></li><li><a href=\"https://www.microsoft.com/en-in/windows/microsoft-edge\" target=\"_blank\"><img src=" + iconEdge + " /><p>" + $translate.instant('Platform_BrowserEdgeVersion') + "</p></a></li><li><a href=\"https://support.apple.com/en_IN/downloads/safari\" target=\"_blank\"><img style='width:25px;' src=" + iconSafari + " /><p>" + $translate.instant('Platform_BrowserSafariVersion') + "</p></a></li></ul>",
                            titleTextColor: "browser-unsupported-header-text",
                            buttons: [
                                {
                                    title: $translate.instant('updateLaterBtn'),
                                    result: "Update Later"
                                }
                            ]
                        };
                    }
                    else {
                        unsupportedBrowser = {
                            type: "unsupportedBrowser",
                            message: "<em>" + browserDetail[0] + "</em> " + $translate.instant("browserIncompatibleMsg") + "<ul class=\"browser-list\"><li><a href=\"https://www.google.com/chrome/browser/desktop/index.html?brand=CHBD&gclid=EAIaIQobChMIuPufvL320gIVwpe9Ch3VhQUtEAAYASAAEgJ8ifD_BwE\" target=\"_blank\"><img src=" + iconChrome + " /><p>" + $translate.instant('broswerChrome') + "</p></a></li><li><a href=\"https://www.microsoft.com/en-in/windows/microsoft-edge\" target=\"_blank\"><img src=" + iconEdge + " /><p>" + $translate.instant('browserEdge') + "</p></a></li></ul>",
                            titleTextColor: "browser-unsupported-header-text",
                            buttons: [
                                {
                                    title: $translate.instant('updateLaterBtn'),
                                    result: "Update Later"
                                }
                            ]
                        };
                    }

                    var unsupportedBrowserVersion = {
                        type: "unsupportedBrowserVersion",
                        message: $translate.instant('yourCurrentBrowser') + "<em>" + browserDetail[0] + ' ' + $translate.instant('version') + browserDetail[1] + "</em> " + $translate.instant("browserIncompatibleMsg") + "<ul class=\"browser-list\"><li><a href=\"https://www.google.com/chrome/browser/desktop/index.html?brand=CHBD&gclid=EAIaIQobChMIuPufvL320gIVwpe9Ch3VhQUtEAAYASAAEgJ8ifD_BwE\" target=\"_blank\"><img src=" + iconChrome + " /><p>" + $translate.instant('broswerChrome') + "</p></a></li></ul>",
                        titleTextColor: "browser-version-header-text",
                        buttons: [
                            {
                                title: $translate.instant('updateLaterBtn'),
                                result: "Update Later"
                            }
                        ]
                    };

                    var standalone = window.navigator.standalone,
                    userAgent = window.navigator.userAgent.toLowerCase(),
                    mobile = /iphone|ipod|ipad|android/.test(userAgent);
                    if (mobile) {
                        return false;
                    }
                    else {
                        if ((browserSniffing[0] == "Chrome" && browserSniffing[1] < 45)) {
                            notification.notify(unsupportedBrowserVersion, function (result) {
                            });
                        }

			    var loginSupportPopup = window.localStorage.getItem("loginsupportedPopupVisible");
			    if (loginSupportPopup != undefined || loginSupportPopup != null || loginSupportPopup == "true") {
            			return;
        			}
                        if (APPCONSTANTS && APPCONSTANTS.userPreferences && APPCONSTANTS.userPreferences.IsNextGen) {
                            if (browserSniffing[0] != "Chrome" &&
                                browserSniffing[0] != "Edge" &&
                                browserSniffing[0] != "Safari") {
                                notification.notify(unsupportedBrowser, function (result) { 
					if((loginSupportPopup || loginSupportPopup == "true"))
					{
						return true;
					}
				if(result.result =="Update Later")
					{
					window.localStorage.setItem("loginsupportedPopupVisible", "true");
					}
				});
                            }

                            if((browserSniffing[0] == "Chrome" &&  Number(browserSniffing[1]) < 80 || browserSniffing[0] == "Edge" &&  Number(browserSniffing[1]) < 80 || browserSniffing[0] == "Safari" &&  Number(browserSniffing[1]) < 13.1))
                            {
				    if((loginSupportPopup || loginSupportPopup == "true"))
					{
						return true;
					}
                             notification.notify(unsupportedBrowser, function (result) {
			     if(result.result =="Update Later")
					{
					window.localStorage.setItem("loginsupportedPopupVisible", "true");
					}
			     });
                            }
                        }
                        else {
                            if (browserSniffing[0] != "Chrome" && browserSniffing[0] != "Edge") {
                                notification.notify(unsupportedBrowser, function (result) { });
                            }
                        }
                    }
                }
            }
        };
    }]);
})();
